<template>
  <div class="container">
    <div class="shed-container" :class="{ shedBg: !isLeft }">
      <div class="shed-wrap">
        <div @click="headClick" class="shed-header">
          <div class="shed-item left opacity" data-index="0">基础信息</div>
          <div class="shed-item right" data-index="1">动态信息</div>
        </div>
        <div class="shed-body">
          <div class="shed-in" v-show="isLeft">
            <div class="infor_params_">
              <div class="title">
                <img src="./img/icon_gear_default.png" />
                <span>区域参数</span>
              </div>
              <el-row class="infor_params_box">
                <el-col :span="8">
                  <p>
                    <label for="">区域名称：</label
                    ><span class="infor_params_value">{{
                      areaName ? areaName : "--"
                    }}</span>
                  </p>
                </el-col>
                <el-col :span="8">
                  <p>
                    <label for="">料棚面积：</label
                    ><span class="infor_params_value">{{
                      areaSize ? areaSize : "--"
                    }}</span>
                  </p>
                </el-col>
                <el-col :span="8">
                  <p>
                    <label for="">高度：</label
                    ><span class="infor_params_value">{{
                      areaHeight ? areaHeight : "--"
                    }}</span>
                  </p>
                </el-col>
              </el-row>
              <el-row class="infor_params_box">
                <el-col :span="8">
                  <p>
                    <label for="">进出口：</label
                    ><span class="infor_params_value">{{
                      areaDoors ? areaDoors : "--"
                    }}</span>
                  </p>
                </el-col>
                <el-col :span="8">
                  <p>
                    <label for="">堆料种类：</label
                    ><span class="infor_params_value">{{
                      areaType ? areaType : "--"
                    }}</span>
                  </p>
                </el-col>
                <el-col :span="8">
                  <p>
                    <label for="">堆料方式：</label
                    ><span class="infor_params_value">--</span>
                  </p>
                </el-col>
              </el-row>
              <el-row class="infor_params_box">
                <el-col :span="8">
                  <p>
                    <label for="">分区：</label
                    ><span class="infor_params_value">{{
                      "x" + shedList.filter((item) => item.type === 6).length
                    }}</span>
                  </p>
                </el-col>
              </el-row>
              <div class="title">
                <img src="./img/icon_gear_default.png" />
                <span>治理设备</span>
              </div>
              <el-row class="infor_params_box">
                <el-col :span="8">
                  <p>
                    <label for="">雾炮：</label
                    ><span class="infor_params_value">{{
                      "x" + fogDevice.length + "台"
                    }}</span>
                  </p>
                </el-col>
              </el-row>
              <div class="title">
                <img src="./img/icon_gear_default.png" />
                <span>监测设备</span>
              </div>
              <el-row class="infor_params_box">
                <el-col :span="8">
                  <p>
                    <label for="">TSP：</label
                    ><span class="infor_params_value">{{
                      "x" + regionsTspAll.length + "台"
                    }}</span>
                  </p>
                </el-col>
                <el-col :span="8">
                  <p>
                    <label for="">VDM：</label
                    ><span class="infor_params_value">{{
                      "x" + vdm150List.length + "台"
                    }}</span>
                  </p>
                </el-col>
                <el-col :span="8">
                  <p>
                    <label for="">全景：</label
                    ><span class="infor_params_value">{{
                      "x" + videoList.length + "台"
                    }}</span>
                  </p>
                </el-col>
              </el-row>
              <div class="title">
                <img src="./img/icon_gear_default.png" />
                <span>洗车机</span>
              </div>
              <el-row class="infor_params_box">
                <el-col :span="8">
                  <p>
                    <label for="">洗车机：</label
                    ><span class="infor_params_value">{{
                      "x" + regionsWashAll.length + "台"
                    }}</span>
                  </p>
                </el-col>
              </el-row>
              <div class="basicInfo">
                <div class="basicInfo-title">
                  沙钢4#料棚 - {{ areaSize ? areaSize : "--" }}
                </div>
                <div class="basicInfo-body">
                  <div class="w-val">{{ areaLen + "米" }}</div>
                  <div class="h-val">{{ areaWidth + "米" }}</div>
                </div>
              </div>
            </div>
          </div>
          <div class="shed-in padding-class" v-show="!isLeft">
            <div class="check-box">
              <div>
                <div
                  @click="
                    ($event) => {
                      clickBtn($event, 1);
                    }
                  "
                  class="btnItem dselected slide"
                >
                  <span class="btnText">电子围栏(侧面)</span>
                </div>
              </div>
              <div>
                <div
                  @click="
                    ($event) => {
                      clickBtn($event, 2);
                    }
                  "
                  class="btnItem dselected top"
                >
                  <span class="btnText">电子围栏(顶面)</span>
                </div>
              </div>
              <div>
                <div
                  @click="
                    ($event) => {
                      clickBtn($event, 3);
                    }
                  "
                  class="btnItem dselected matter"
                >
                  <span class="btnText">污染事件</span>
                </div>
              </div>
            </div>
            <div class="illus-bar">
              <ul class="ui-choose" multiple="multiple" id="uc_03">
                <li
                  @click="
                    ($event) => {
                      initIllus_($event, 2);
                    }
                  "
                  class="wupao"
                >
                  雾炮<span class="number">{{ fogDevice.length }}</span>
                  <div class="imgIcon">
                    <img class="ui-icon" src="./img/foggun.png" />
                  </div>
                  <span class="unit">台</span>
                </li>
                <li
                  @click="
                    ($event) => {
                      initIllus_($event, 3);
                    }
                  "
                  class="vdm150"
                >
                  vdm<span class="number">{{ vdm150List.length }}</span>
                  <div class="imgIcon">
                    <img class="ui-icon" src="./img/VDM.png" />
                  </div>
                  <span class="unit">台</span>
                </li>
                <li
                  @click="
                    ($event) => {
                      initIllus_($event, 5);
                    }
                  "
                >
                  鹰眼<span class="number">{{
                    shedList.filter((item) => item.type === 4).length
                  }}</span>
                  <div class="imgIcon">
                    <img class="ui-icon" src="./img/yingyan.png" />
                  </div>
                  <span class="unit">台</span>
                </li>
                <li
                  @click="
                    ($event) => {
                      initIllus_($event, 6);
                    }
                  "
                >
                  洗车机<span class="number">{{ regionsWashAll.length }}</span>
                  <div class="imgIcon">
                    <img class="ui-icon" src="./img/washcar.png" />
                  </div>
                  <span class="unit">台</span>
                </li>
              </ul>
            </div>
            <div class="shed-outer" @click="clickHandle">
              <!-- 电子围栏 / vdm 1+2 -->
              <div v-if="isSlide">
                <template
                  v-for="(item, i) in regions"
                  v-bind:key="item.deviceNo"
                >
                  <div
                    :id="item.deviceNo"
                    :class="{
                      bb: true,
                    }"
                    data
                    :style="getRegionStyle(item, i)"
                    @mouseleave="mouseleaveHandle"
                    @mousemove="mouseoverHandle(item)"
                  >
                    <img :data-index="'vdm' + i" :src="item.base64" alt="" />
                    <div
                      :data-index="'click' + i"
                      :style="getfogDStyle(item, i)"
                      class="realTime"
                    >
                      {{ item.realTimeValue ? item.realTimeValue : "--" }}
                    </div>
                  </div>
                </template>
              </div>
              <!-- 雾炮设备 -->
              <div v-if="fogShow">
                <template
                  v-for="(item, i) in fogDevice"
                  v-bind:key="item.deviceNo"
                >
                  <div
                    :id="item.deviceNo"
                    :class="{
                      bb: true,
                    }"
                    :style="getRegionStyle(item, i)"
                    style="z-index: 999"
                  >
                    <img :data-index="'imgFog' + i" :src="item.base64" alt="" />
                  </div>
                </template>
              </div>
              <!-- 顶部 -->
              <div v-if="isVdm150">
                <template
                  v-for="(item, i) in shedTop"
                  v-bind:key="item.deviceNo"
                >
                  <div
                    :id="item.deviceNo"
                    :class="{
                      bb: true,
                    }"
                    :style="getRegionStyle(item, i)"
                    @mouseleave="mouseleaveHandle"
                    @mousemove="mouseoverHandle(item)"
                  >
                    <img :data-index="'top' + i" :src="item.base64" alt="" />
                    <!-- <div data-index="" class="realTime">
                      {{ item.realTimeValue ? item.realTimeValue : "--" }}
                    </div> -->
                  </div>
                </template>
              </div>
              <!-- 雾炮区域 -->
              <div v-if="isFogArea" style="positon: relative">
                <template
                  v-for="(item, i) in fogArea"
                  v-bind:key="item.deviceNo"
                >
                  <div
                    :id="item.deviceNo"
                    :class="{
                      bb: true,
                    }"
                    :style="getRegionStyle(item, i)"
                    @mouseleave="mouseleaveHandle"
                    @mousemove="mouseoverHandle(item)"
                  >
                    <img :data-index="'imgFog' + i" :src="item.base64" alt="" />
                    <!-- <div data-index="" class="realTime">
                      {{ item.realTimeValue ? item.realTimeValue : "--" }}
                    </div> -->
                  </div>
                </template>
              </div>
              <!-- vdm150 -->
              <div v-if="vdmShow">
                <template
                  v-for="(item, i) in vdm150List"
                  v-bind:key="item.deviceNo"
                >
                  <div
                    :id="item.deviceNo"
                    :class="{
                      bb: true,
                    }"
                    :style="getRegionStyle(item, i)"
                  >
                    <img :data-index="'top' + i" :src="item.base64" alt="" />
                  </div>
                </template>
              </div>
              <!-- 全景相机 -->
              <div v-if="eagleShow">
                <template
                  v-for="(item, i) in videoList"
                  v-bind:key="item.deviceNo"
                >
                  <div
                    :id="item.deviceNo"
                    :class="{
                      bb: true,
                    }"
                    :style="getRegionStyle(item, i)"
                  >
                    <img :src="item.base64" alt="" />
                  </div>
                </template>
              </div>
              <div v-if="washShow">
                <template
                  v-for="(item, i) in regionsWashAll"
                  v-bind:key="item.deviceNo"
                >
                  <div
                    :id="item.deviceNo"
                    :class="{
                      bb: true,
                    }"
                    :style="getRegionStyle(item, i)"
                    style="z-index: 999"
                  >
                    <img :data-index="'wash' + i" :src="item.base64" alt="" />
                  </div>
                </template>
              </div>
              <!-- 弹窗 -->
              <div class="toolTip" ref="toolTip">
                <div class="header">区域【{{ curHoverDeviceNo }}】</div>
                <div class="bodyBottom">
                  <div>
                    <span>面积</span>
                    <span>{{ curLen * curWidth + "米²" }}</span>
                  </div>
                  <div>
                    <span>尺寸</span>
                    <span>{{
                      "长：" +
                      (curLen ? curLen : 0) +
                      "米； 宽：" +
                      (curWidth ? curWidth : 0) +
                      "米"
                    }}</span>
                  </div>
                  <div v-if="fogNum">
                    <span>雾炮</span>
                    <span>{{ fogCount }}</span>
                  </div>
                  <div v-if="vdm150Num">
                    <span>VDM</span>
                    <span>{{ vdm150Count }}</span>
                  </div>
                  <div v-if="vdm12Num">
                    <span>VDM1+2</span>
                    <span>{{ vdm12Count }}</span>
                  </div>
                </div>
              </div>
              <vdmShed
                v-if="isVdm"
                :detailPopup="detailPopup"
                @closeVdm="closeVdm"
              ></vdmShed>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="return-btn" @click="returnFunc()">
      <span></span>
    </div>
  </div>
</template>

<script>
import { unref, computed, nextTick } from "vue";
import vdmShed from "@/modules/unorganizedComponents/vdmBar/vdmDevice/vdmShed.vue";
export default {
  components: {
    vdmShed,
  },
  data() {
    return {
      isSlide: false,
      isLeft: false,
      isVdm150: false,
      isFogArea: false,
      isVdm: false,
      sampledataHeight: 0,

      isHorizon: false,
      currItem: null,
      rateHW: 1,
      realHeight: 0,
      realWidth: 1730,

      areaName: "",
      areaSize: "",
      areaNum: "",
      areaLen: "",
      areaWidth: "",
      areaHeight: "",
      areaDoors: " x 2",
      areaType: "干料",
      areaStyle: "",

      regions: [],

      regionsFogStatusRelate: {},
      layouts: [],
      vdmSignalRelate: {},
      fogSignalRelate: {},
      curVideoNo: "",

      vdmIdx: {},

      regionsVdmRelate: {},
      regionsFogRelate: {},

      regionsVdmRelateIdx: {},
      regionsPosList: [],

      regionsVdm: {},
      regionsFog: {},
      regionsTsp: {},
      regionsEagle: {},

      regionsVdmAll: [],
      regionsFogAll: [],
      regionsFogObjAll: {},
      regionsTspAll: [],
      regionsEagleAll: [],
      regionsWashAll: [],

      cameraObj: {},
      cameraAddressIp: "",

      regionsShow: true,
      regionsValShow: true,
      vdmShow: false,
      tspShow: false,
      washShow: false,
      eagleShow: false,
      fogShow: false,

      curHoverDeviceNo: "",
      curLen: 0,
      curWidth: 0,

      curClickDeviceNo: "",

      dusters: [],

      vdms: [],
      imgListInfoArr: [],
      imgListArr: [],
      imgUrl: [],
      vdmChart: [],
      imgCache: [],
      cacheFinished: [],
      cacheST: [],
      diaporamaShow: [],
      options: [],
      imgIdx: [],

      vehicles: [],
      imgVehiclesListInfoArr: [],
      imgVehiclesListArr: [],
      imgVehiclesUrl: [],
      vehiclesChart: [],
      imgVehiclesCache: [],
      vehiclesCacheFinished: [],
      vehiclesCacheST: [],
      vehiclesDiaporamaShow: [],
      vehiclesOptions: [],
      imgVehiclesIdx: [],

      warns: [],
      imgWarnsListInfoArr: [],
      imgWarnsListArr: [],
      imgWarnsUrl: [],
      warnsChart: [],
      imgWarnsCache: [],
      warnsCacheFinished: [],
      warnsCacheST: [],
      warnsDiaporamaShow: [],
      warnsOptions: [],
      imgWarnsIdx: [],

      showFogVideo: false,
      curGovernTimeValue: {},

      curHoverWashCarNo: "",
      curHoverWashCarInfo: {},
      lastWashRecord: [],

      washCarPower: false,

      washCarHoverTimer: null,

      maxWashCarPressure: null,
      minWashCarPressure: null,

      showCarDetail: false,

      shedPngMap: {
        "38_005": "shed038_003.png",
        "38_001": "shed038_001.png",
        "38_004": "shed038_001.png",
      },

      shedNo: "",
      base64: "",
      shedInfo: {},
      noNeedProcessList: [46, 54],
      maxRealTimeValue: "",

      fogDevice: [],
      shedTop: [],
      fogArea: [],
      vdm150List: [],
      videoList: [],
      shedList: [],
      vdmMap: {},
      fogMap: {},
      aside: {},
      detailPopup: {},
      vdm12Count: "",
      vdm150Count: "",
      fogCount: "",
      vdm12Num: 0,
      vdm150Num: 0,
      fogNum: 0,
    };
  },
  inject: {
    updateAllEmissionVdmId: {
      from: "updateAllEmissionVdmId",
      default: () => "",
    },
    getAllEmissionVdmId: {
      from: "getAllEmissionVdmId",
      default: () => "",
    },
    getDeviceTabs: {
      from: "getDeviceTabs",
      default: () => "",
    },
    getVdmArea: {
      from: "getVdmArea",
      default: () => "",
    },
    updateVdmArea: {
      from: "updateVdmArea",
      default: () => "",
    },

    updateLeftRightPart: {
      from: "updateLeftRightPart",
      default: () => "",
    },
    updateSourceShow: {
      from: "updateSourceShow",
      default: () => "",
    },
    updateEmissionLoading: {
      from: "updateEmissionLoading",
      default: () => "",
    },
  },
  watch: {
    getVdmArea: {
      handler(newVal, oldVal) {
        //debugger;
        this.materialObj = unref(newVal);
        //this.$forceUpdate();
        if (this.materialObj) {
          let that = this;
          that.signalList = [];
          this.shedId = this.materialObj.shedNo;
          this.shedName = this.materialObj.shedName;
        }
        this.initFunc();
      },
      deep: true,
    },
  },
  computed: {
    getRegionStyle() {
      return function (item, i) {
        let zIndex;
        if (item.deviceName.indexOf("4#料棚雾顶部") !== -1) {
          switch (i) {
            case 0:
            case 2:
              zIndex = 1;
              break;
            case 1:
              zIndex = 1;
              break;
          }
        } else {
          zIndex = 1;
        }
        return {
          position: "absolute",
          left: parseInt(item.leftAddress) + "px",
          top: parseInt(item.topAddress) + "px",
          width: parseInt(item.regionLength) + "px",
          height: parseInt(item.regionWith) + "px",
          //transform: "scale(0.5)",
          transformOrigin: "center center",
          zIndex,
        };
      };
    },
    getfogDStyle() {
      return function (item, i) {
        switch (i) {
          case 6:
            return {
              transform: "rotate(60deg)",
            };
          case 7:
          case 13:
          case 14:
          case 15:
            return {
              writingMode: "vertical-lr",
            };
        }
      };
    },
    getTipStyle() {
      return function (currItem) {
        const { item, index } = currItem;
        if (item.deviceName.indexOf("4#料棚雾炮区域") !== -1) {
          return {
            position: "absolute",
          };
        } else if (item.type === 5) {
        }
      };
    },
  },
  methods: {
    returnFunc() {
      this.shedId = false;
      this.$forceUpdate();
      if (this.updateVdmArea) {
        this.updateVdmArea("");
      }
      if (
        this.updateAllEmissionVdmId &&
        typeof this.updateAllEmissionVdmId === "function"
      ) {
        this.updateAllEmissionVdmId(false);
      }
      if (this.updateLeftRightPart) {
        this.updateLeftRightPart(false);
      }
      if (this.updateSourceShow) {
        this.updateSourceShow(false);
      }
      if (this.updateEmissionLoading) {
        this.updateEmissionLoading(false);
      }
      if (this.getShedTimer) {
        clearTimeout(this.getShedTimer);
      }
      $(".bringins-block").fadeOut(500, function () {
        $(".bringins-block").remove();
      });
    },
    headClick(event) {
      if (event.target.nodeName.toLowerCase() === "div") {
        const index = parseInt(event.target.getAttribute("data-index"));
        if (index === 0) {
          $(".left").removeClass("opacity");
          $(".right").addClass("opacity");
          this.isLeft = true;
        } else {
          $(".right").removeClass("opacity");
          $(".left").addClass("opacity");
          this.isLeft = false;
        }
      }
    },
    initIllus_(event, index) {
      if ($(event.currentTarget).hasClass("selected")) {
        if (index === 0) {
          let regionsShow = false;
          this.regionsShow = regionsShow;
          $(".bb").hide();
        } else if (index === 1) {
          let regionsValShow = false;
          this.regionsValShow = regionsValShow;
          $(".t_mbox").hide();
        } else if (index === 3) {
          let vdmShow = false;
          this.vdmShow = vdmShow;
          $(".vdmEquip").hide();
        } else if (index === 4) {
          let tspShow = false;
          this.tspShow = tspShow;
          $(".tspEquip").hide();
        } else if (index === 6) {
          let washShow = false;
          this.washShow = washShow;
          $(".washEquip").hide();
        } else if (index === 5) {
          let eagleShow = false;
          this.eagleShow = eagleShow;
          $(".eagleEquip").hide();
        } else if (index === 2) {
          let fogShow = false;
          this.fogShow = fogShow;
          $(".fogEquip").hide();
        }
        $(event.currentTarget).removeClass("selected");
      } else {
        if (index === 0) {
          let regionsShow = true;
          this.regionsShow = regionsShow;
          $(".bb").show();
        } else if (index === 1) {
          let regionsValShow = true;
          this.regionsValShow = regionsValShow;
          $(".t_mbox").show();
        } else if (index === 3) {
          let vdmShow = true;
          this.vdmShow = vdmShow;
          $(".vdmEquip").show();
        } else if (index === 4) {
          let tspShow = true;
          this.tspShow = tspShow;
          $(".tspEquip").show();
        } else if (index === 6) {
          let washShow = true;
          this.washShow = washShow;
          $(".washEquip").show();
        } else if (index === 5) {
          let eagleShow = true;
          this.eagleShow = eagleShow;
          $(".eagleEquip").show();
        } else if (index === 2) {
          let fogShow = true;
          this.fogShow = fogShow;
          $(".fogEquip").show();
        }
        $(event.currentTarget).addClass("selected");
      }
    },
    clickBtn(event, index) {
      if ($(event.currentTarget).hasClass("dselected")) {
        if (index === 1) {
          $(".slide").removeClass("btnItem dselected");
          $(".slide").addClass("btnItemS selected");
          $(".top").removeClass("btnItemS selected");
          $(".top").addClass("btnItem dselected");
          $(".matter").removeClass("btnItemS selected");
          $(".matter").addClass("btnItem dselected");
          this.isSlide = true;
          this.isVdm150 = false;
          this.isFogArea = false;
          this.vdmShow = false;
          this.fogShow = false;
          $(".vdm150").removeClass("selected");
          $(".wupao").removeClass("selected");
        } else if (index === 2) {
          $(".top").removeClass("btnItem dselected");
          $(".top").addClass("btnItemS selected");
          $(".slide").removeClass("btnItemS selected");
          $(".slide").addClass("btnItem dselected");
          $(".matter").removeClass("btnItemS selected");
          $(".matter").addClass("btnItem dselected");
          this.isSlide = false;
          this.isVdm150 = true;
          this.isFogArea = false;
          let vdmShow = true;
          this.vdmShow = vdmShow;
          this.fogShow = false;
          $(".vdmEquip").show();
          $(".vdm150").addClass("selected");
          $(".wupao").removeClass("selected");
        } else {
          $(".matter").removeClass("btnItem dselected");
          $(".matter").addClass("btnItemS selected");
          $(".slide").removeClass("btnItemS selected");
          $(".slide").addClass("btnItem dselected");
          $(".top").removeClass("btnItemS selected");
          $(".top").addClass("btnItem dselected");
          this.isSlide = false;
          this.isVdm150 = false;
          this.isFogArea = true;
          let fogShow = true;
          this.fogShow = fogShow;
          this.vdmShow = false;
          $(".fogEquip").show();
          $(".vdm150").removeClass("selected");
          $(".wupao").addClass("selected");
        }
      } else {
        if (index === 1) {
          $(".slide").addClass("btnItem dselected");
          $(".slide").removeClass("btnItemS selected");
          $(".top").removeClass("btnItemS selected");
          $(".top").addClass("btnItem dselected");
          $(".matter").removeClass("btnItemS selected");
          $(".matter").addClass("btnItem dselected");
          this.isSlide = false;
        } else if (index === 2) {
          $(".top").addClass("btnItem dselected");
          $(".top").removeClass("btnItemS selected");
          $(".slide").removeClass("btnItemS selected");
          $(".slide").addClass("btnItem dselected");
          $(".matter").removeClass("btnItemS selected");
          $(".matter").addClass("btnItem dselected");
          this.isVdm150 = false;
          let vdmShow = false;
          this.vdmShow = vdmShow;
          $(".vdmEquip").hide();
          $(".vdm150").removeClass("selected");
        } else {
          $(".matter").addClass("btnItem dselected");
          $(".matter").removeClass("btnItemS selected");
          $(".slide").removeClass("btnItemS selected");
          $(".slide").addClass("btnItem dselected");
          $(".top").removeClass("btnItemS selected");
          $(".top").addClass("btnItem dselected");
          this.isFogArea = false;
          let fogShow = false;
          this.fogShow = fogShow;
          $(".fogEquip").hide();
          $(".wupao").removeClass("selected");
        }
      }
    },
    // 默认选中电子围栏
    defaultSelect() {
      if($(".slide").hasClass("dselected")) {
        $(".slide").removeClass("btnItem dselected");
        $(".slide").addClass("btnItemS selected");
        this.isSlide = true;
      }
    },
    // 获取料棚设备信息
    async getShedDeviceInfo() {
      // let url = CONFIG.requestName + this.$apiOpt.detailNew;
      let url = "http://screen.bmetech.com/screen" + this.$apiOpt.detailNew;
      try {
        let res = await this.$apiUtils.get(url, {
          customerId: this.$store.state.customerId,
          // customerId: "39",
          shedNo: this.materialObj.shedNo,
          // shedNo: "39_004",
        });
        this.areaName = res.basic.shedName;
        this.areaLen = res.basic.leng;
        this.areaWidth = res.basic.width;
        this.shedNo = res.basic.shedNo;
        var canvas = document.createElement("canvas");
        var ctx = canvas.getContext("2d");
        var img = new Image();
        this.areaNum = res.basic.area;
        this.areaSize =
          res.basic.area +
          "米² (" +
          res.basic.leng +
          "米 x " +
          res.basic.width +
          "米)";
        this.areaHeight = "";
        this.areaType = res.basic.material;
        this.areaStyle = res.basic.areaName;
        return res;
      } catch (err) {
        console.error(err);
      }
    },
    async initFunc() {
      let shedInfo = await this.getShedDeviceInfo();
      this.shedInfo = shedInfo;
      this.renderShedBar();
    },
    renderShedBar() {
      if ($.isEmptyObject(this.shedInfo)) {
        return;
      }
      let cameraObj = this.shedInfo.camera;
      cameraObj.forEach((item) => {
        this.cameraObj[item.videoNo] = item.cameraIpAddress;
      });
      let shedList = this.shedInfo.layout;
      this.shedList = shedList;
      shedList.forEach((item) => {
        if (item.deviceName.indexOf("4#料棚围栏区域") !== -1) {
          this.aside[item.deviceNo] = {
            deviceName: item.deviceName,
            regionLength: item.regionLength,
            regionWith: item.regionWith
          };
        }
      });
      shedList.forEach((item, i) => {
        if (item.deviceType === "电子围栏") {
          if (item.type === 7) {
            if (this.aside[item.regions]) {
              item.deviceName = this.aside[item.regions]["deviceName"];
              item.width = this.aside[item.regions]["regionWith"];
              item.length = this.aside[item.regions]["regionLength"];
            }
            this.regions.push(this.renderImg(item, item.id));
          }
        } else if (item.deviceType === "雾炮") {
          this.fogMap[item.regions] = {
            status: item.status,
            realTimeValue: item.realTimeValue,
          };
          if (item.type === 2) {
            this.fogDevice.push(this.renderImg(item, "wupao"));
          }
        } else if (item.type === 5) {
          this.vdmMap[item.regions] = {
            status: item.status,
            realTimeValue: item.realTimeValue,
          };
          this.vdm150List.push(this.renderImg(item, "vdm150"));
        } else if (item.deviceName.indexOf("4#料棚雾炮区域") !== -1) {
          if (this.fogMap[item.deviceNo]) {
            item.status = this.fogMap[item.deviceNo]["status"];
            item.realTimeValue = this.fogMap[item.deviceNo]["realTimeValue"];
          }
          this.fogArea.push(this.renderImg(item, item.deviceNo));
        } else if (item.deviceName.indexOf("一期矿粉料场全景相机") !== -1) {
          this.videoList.push(this.renderImg(item, "caremaquanjing"));
        } else if (item.deviceName.indexOf("4#料棚雾顶部") !== -1) {
          if (this.vdmMap[item.deviceNo]) {
            item.status = this.vdmMap[item.deviceNo]["status"];
            item.realTimeValue = this.vdmMap[item.deviceNo]["realTimeValue"];
          }
          this.shedTop.push(this.renderImg(item, item.deviceNo));
        } else if (item.type === 3) {
          this.regionsWashAll.push(this.renderImg(item, "xicheji"));
        } else if (item.type === 1) {
          this.regionsTspAll.push(item);
        }
      });
    },
    renderImg(item, prop, flag) {
      var img = new Image();
      if (item.status !== 1) {
        img.src = require("@/modules/unorganizedComponents/newShed/img/" +
          prop +
          ".png");
      } else {
        img.src = require("@/modules/unorganizedComponents/newShed/img/" +
          prop +
          "_c" +
          ".png");
      }
      if (img.src) {
        img.onload = function () {
          item.base64 = img.src;
        };
      }
      return item;
    },
    mouseoverHandle(item) {
      const x =
        event.currentTarget.offsetLeft + event.currentTarget.offsetWidth;
      const x_ = event.currentTarget.offsetLeft;
      const y = event.currentTarget.offsetTop;
      if (x < 1000) {
        if (item.deviceType !== "电子围栏") {
          $(this.$refs.toolTip)
            .css("top", y + "px")
            .css("left", x + 20 + "px");
        } else {
          $(this.$refs.toolTip)
            .css("top", y - 300 + "px")
            .css("left", x + 20 + "px");
        }
      } else {
        if (item.deviceType !== "电子围栏") {
          $(this.$refs.toolTip)
            .css("top", y + "px")
            .css("left", x_ - 20 - $(this.$refs.toolTip).outerWidth() + "px");
        } else {
          $(this.$refs.toolTip)
            .css("top", y - 300 + "px")
            .css("left", x_ - 20 - $(this.$refs.toolTip).outerWidth() + "px");
        }
      }
      this.curHoverDeviceNo = item.deviceName;
      if(item.deviceType === '电子围栏') {
        this.curLen = item.length;
        this.curWidth = item.width;
      } else {
        this.curLen = item.regionLength;
        this.curWidth = item.regionWith;
      }
      $(this.$refs.toolTip).show();
      const tmpArr = this.shedList.filter((item) => item.type !== 6);
      let tmpStr;
      if (item.deviceNo.indexOf("39_") !== -1) {
        tmpStr = item.deviceNo;
      } else {
        tmpStr = item.regions;
      }
      const vdm12 = tmpArr.filter(
        (item) => item.regions === tmpStr && item.type === 7
      );
      const vdm150 = tmpArr.filter(
        (item) => item.regions === tmpStr && item.type === 5
      );
      const fog = tmpArr.filter(
        (item) => item.regions === tmpStr && item.type === 2
      );
      this.vdm12Count = `${vdm12.length}台,${
        vdm12[0] ? vdm12[0].deviceNo + "在线" : ""
      }`;
      this.vdm12Num = vdm12.length;
      this.vdm150Count = `${vdm150.length}台,${
        vdm150[0] ? vdm150[0].deviceNo + "在线" : ""
      }`;
      this.vdm150Num = vdm150.length;
      this.fogCount = `${fog.length}台,${
        fog[0] ? fog[0].deviceNo + "在线" : ""
      }`;
      this.fogNum = fog.length;
    },
    mouseleaveHandle(event) {
      $(this.$refs.toolTip).hide();
    },
    clickHandle(event) {
      if (
        (event.target.nodeName.toLowerCase() === "img" ||
          event.target.nodeName.toLowerCase() === "div") &&
        event.target.getAttribute("data-index")
      ) {
        if (
          event.target.getAttribute("data-index").indexOf("vdm") !== -1 ||
          event.target.getAttribute("data-index").indexOf("click") !== -1
        ) {
          let str = event.target.getAttribute("data-index");
          let arr = [];
          if (str.indexOf("vdm") !== -1) {
            arr = str.split("m");
          } else {
            arr = str.split("k");
          }
          let index = arr[1];
          this.detailPopup = this.regions[index];
          this.isVdm = true;
        } else if (
          event.target.getAttribute("data-index").indexOf("imgFog") !== -1
        ) {
          let str = event.target.getAttribute("data-index");
          let arr = str.split("g");
          let index = arr[2];
          this.detailPopup = this.fogDevice[index];
          this.isVdm = true;
        } else if (
          event.target.getAttribute("data-index").indexOf("top") !== -1
        ) {
          let str = event.target.getAttribute("data-index");
          let arr = str.split("p");
          let index = arr[1];
          this.detailPopup = this.vdm150List[index];
          this.isVdm = true;
        } else if (
          event.target.getAttribute("data-index").indexOf("wash") !== -1
        ) {
          let str = event.target.getAttribute("data-index");
          let arr = str.split("h");
          let index = arr[1];
          this.detailPopup = this.regionsWashAll[index];
          this.isVdm = true;
        }
        console.log(this.detailPopup, 'this.detailPopup')
      }
    },
    closeVdm() {
      this.isVdm = false;
    },
  },
  mounted() {
    this.defaultSelect();
  },
  created() {},
  unmounted() {
    Object.assign(this.$data, this.$options.data());
  },
};
</script>

<style lang="scss" scoped>
.container {
  position: absolute;
  top: 0;
  left: 0;
  width: 3835px !important;
  height: 1079px !important;
  background-color: rgba(0, 0, 0, 1);
  z-index: 300000;
}
.shed {
  &-container {
    width: 100%;
    height: 100%;
    padding: 0 30px;
    padding-bottom: 20px;
  }
  &-wrap {
    width: 100%;
    height: 100%;
  }
  &-header {
    position: relative;
    z-index: 100;
    height: 101px;
    display: flex;
    justify-content: center;
  }
  &-item {
    text-align: center;
    font-size: 26px;
    width: 479px;
    height: 100%;
    line-height: 101px;
    color: #ffd083;
    border-bottom: 2px solid #ffd083;
    margin-right: 10px;
    cursor: pointer;
  }
  &-body {
    height: calc(100% - 101px);
    overflow: auto;
    padding: 20px;
  }
  &-in {
    height: 100%;
    font-size: 26px;
  }
  &-bg {
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
    background-image: url("./img/shedBg2.png");
    background-size: 100% 100%;
    z-index: 1;
  }
}
.return-btn {
  z-index: 101;
}
.opacity {
  opacity: 0.5;
}
.infor_params_ {
  padding: 40px 80px 10px;
  width: 70%;
  position: relative;
  left: 50%;
  transform: translateX(-50%);
  background-color: #101422;

  .title {
    margin-bottom: 20px;
    margin-top: 40px;
    img,
    span {
      display: inline-block;
      vertical-align: middle;
      font-size: 32px;
      line-height: 32px;
    }
    img {
      margin-top: 5px;
    }
  }
  .infor_params_title {
    font-size: 32px;
    &:before {
      content: "";
      width: 22px;
      height: 23px;
      background: rgba(61, 223, 226, 1);
      border-radius: 50%;
      position: absolute;
      top: 12px;
      left: -40px;
    }
  }
  .infor_params_box {
    background-color: rgba(13, 18, 29);
    color: #cadbe5;
    display: flex;
    flex-wrap: wrap;
    padding: 5px 20px;
    height: 100px;
    p {
      line-height: 40px;
      display: flex;
      flex-wrap: wrap;
      justify-content: flex-start;
      color: rgb(146, 211, 251);
      label {
        display: inline-block;
        font-size: 28px;
        width: 300px;
        text-align: end;
      }
      span {
        display: inline-block;
        flex: 1;
        //width: 44%;
        margin-right: 30px;
        margin-bottom: 16px;
        color: #ccc;
        font-size: 25px;
        span {
          color: rgb(255, 212, 153);
          font-size: 25px;
        }
      }
      .infor_params_value {
        color: rgb(255, 212, 153);
        font-size: 25px;
        width: 380px;
        border-bottom: 1px dashed #ffd499;
      }
    }
  }
}
.check-box {
  position: absolute;
  z-index: 110;
  top: 275px;
  left: 116px;
  width: 300px;
  height: 250px;
  padding-top: 30px;
  > div {
    width: 100%;
    height: 50%;
  }
  .btnItem {
    width: 100%;
    height: 50px;
    margin-bottom: 10px;
    position: relative;
    cursor: pointer;
    line-height: 50px;
    background-image: url("./img/btnD.png");
    background-size: 100% 100%;
    color: #fff;
  }
  .btnItemS {
    width: 100%;
    height: 50px;
    margin-bottom: 10px;
    position: relative;
    cursor: pointer;
    line-height: 50px;
    background-image: url("./img/btnC.png");
    background-size: 100% 100%;
    color: #47ffdd;
  }
  .btnText {
    position: absolute;
    left: 100px;
    top: 0;
    font-size: 24px;
  }
}
.btnImg {
  width: 300px;
  height: 50px;
}
</style>

<style lang="scss" scoped>
.illus-bar {
  display: flex;
  justify-content: space-around;
  margin-bottom: 90px;
  position: relative;
  z-index: 100;
}
.number {
  font-family: "number";
}
.ui-choose > li .number {
  font-size: 50px;
  color: rgb(255, 168, 107);
  display: block;
  position: absolute;
  top: -45px;
  width: 100px;
  right: 0;
  height: 100%;
}
.ui-choose > li .unit {
  font-size: 18px;
  color: #fff;
  display: block;
  position: absolute;
  top: 6px;
  width: 100px;
  right: 0;
  height: 100%;
}
.ui-choose > li.selected {
  opacity: 1;
}
.ui-choose > li .area {
  font-size: 28px;
  vertical-align: top;
  display: inline-block;
  margin-top: 50px;
  position: relative;
  line-height: 1;
}
ul.ui-choose > li.selected > .ui-icon {
  opacity: 1 !important;
}
.ui-choose {
  width: 90%;
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  margin-bottom: 40px;
  margin-top: 20px;
}

.ui-choose > li {
  line-height: 185px !important;
  font-size: 20px !important;
  @include bg-box(260px, 124px, "iconli.png");
  opacity: 0.5;
  padding-right: 115px;
  text-align: center;
  position: relative;
  color: #fff;
  font-weight: 600;
  zoom: 0.7;
  margin-right: 100px;
}
.imgIcon {
  position: absolute;
  top: 0;
  width: 132px;
  height: 120px;
}
.ui-icon {
  //width: 65px;
  margin: 0 auto;
  margin-top: 20px;
}
</style>
<style lang="scss" scoped>
.shed-outer {
  position: absolute;
  height: 100%;
  width: 100%;
  top: -40px;
  left: 0;
  background-image: url("./img/shedBg.png");
  background-size: 100% 100%;
}
.realTime {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  color: #51eeff;
  text-align: center;
}
.toolTip {
  position: absolute;
  width: 620px;
  height: 300px;
  z-index: 99999;
  display: none;
  background-color: #000;
  border: 1px solid #e79d26;
  border-radius: 10px;
  .header {
    height: 60px;
    background: rgba(245, 166, 35, 0.13);
    border-bottom: 1px solid #e79d26;
    font-size: 26px;
    text-align: center;
    line-height: 60px;
  }
  .bodyBottom {
    > div {
      width: 100%;
      height: 80px;
      line-height: 80px;
      text-align: left;
      display: flex;
      justify-content: space-around;
      > span:nth-child(2) {
        color: #bcebff;
      }
    }
  }
}
</style>
<style lang="scss" scoped>
.vdm-shed {
  position: absolute;
  z-index: 3000001;
  width: 1422px;
  height: 778px;
  background-color: #fff;
}
.basicInfo {
  width: 100%;
  height: 700px;
  &-title {
    height: 150px;
    line-height: 150px;
    text-align: center;
    color: #63c590;
    font-size: 30px;
  }
  &-body {
    position: relative;
    height: calc(100% - 150px);
    background-image: url("./img/shedBg1.png");
    background-size: 100% 100%;
  }
}
.h-val {
  position: absolute;
  top: 98px;
  left: 467px;
  height: 50%;
  text-align: center;
  font-size: 24px;
  color: mediumspringgreen;
  transform: rotate(-90deg) translate(0, 100%);
  transform-origin: 0% 100%;
}
.w-val {
  position: absolute;
  top: 125px;
  left: 0px;
  width: 100%;
  text-align: center;
  font-size: 24px;
  color: mediumspringgreen;
}
.padding-class {
  padding-top: 30px;
}
.shedBg {
  width: 100%;
  height: 100%;
  background-image: url("./img/shedBg2.png");
  background-size: 100% 100%;
}
</style>